import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { PaymentAllocation } from 'src/features/paymentAllocations/utils/types';

const RESOURCE = '/payments/payment-allocation/:allocationId/';

type QueryFnType = typeof queryFn;

interface DTO {
    allocationId: string;
}
const queryFn = ({ allocationId }: DTO): Promise<PaymentAllocation> => {
    return axios.get(formatResourcePath(RESOURCE, { allocationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPaymentAllocation, RESOURCE as PAYMENT_ALLOCATION_RESOURCE };
